/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lernfoerderungduerchfuehrungstagchoosen3Inputs */

const de__field_lernfoerderungduerchfuehrungstagchoosen3 = /** @type {(inputs: _Field_Lernfoerderungduerchfuehrungstagchoosen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewählte Tage für Lernförderung`)
};

/**

* @param {_Field_Lernfoerderungduerchfuehrungstagchoosen3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lernfoerderungduerchfuehrungstagchoosen3 = /** @type {((inputs?: _Field_Lernfoerderungduerchfuehrungstagchoosen3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lernfoerderungduerchfuehrungstagchoosen3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lernfoerderungduerchfuehrungstagchoosen3(inputs)
});
export { _field_lernfoerderungduerchfuehrungstagchoosen3 as "_field_lernfoerderungDuerchfuehrungsTagChoosen" }